import * as joint from '@clientio/rappid';

import { VerticeCalculatorInput } from './link-adjust-types';
import RouterConfig from '../custom-router/Router.config';

export class BaseLinkVerticeCalculator {
  getIrregularMargin(anchor: string): number {
    const margin = RouterConfig.padding;
    if (anchor === 'left') {
      return -margin;
    } else if (anchor === 'right') {
      return margin;
    } else if (anchor === 'top') {
      return -margin;
    } else if (anchor === 'bottom') {
      return margin;
    }
  }

  setFirstHorizontalVertices(input: VerticeCalculatorInput, newVertices: joint.dia.Point[], mouseEvent: MouseEvent, verticeIndex: number) {
    const sourcePoint = input.sourcePoint;
    const sourceAnchor = input.sourceAnchor;
    const startPoint = input.startPoint;
    const vertices = input.vertices;
    const startMouseY = input.startMouseY;
    const i = verticeIndex;

    newVertices.push({
      x: sourcePoint.x + this.getIrregularMargin(sourceAnchor),
      y: sourcePoint.y,
    });
    newVertices.push({
      x: sourcePoint.x + this.getIrregularMargin(sourceAnchor),
      y: sourcePoint.y + (mouseEvent.clientY - startMouseY),
    });
    newVertices.push({ x: vertices[i].x, y: startPoint + (mouseEvent.clientY - startMouseY) });
  }

  setFirstVerticalVertices(input: VerticeCalculatorInput, newVertices: joint.dia.Point[], mouseEvent: MouseEvent, verticeIndex: number) {
    const sourcePoint = input.sourcePoint;
    const sourceAnchor = input.sourceAnchor;
    const startPoint = input.startPoint;
    const vertices = input.vertices;
    const startMouseX = input.startMouseX;
    const i = verticeIndex;

    newVertices.push({
      x: sourcePoint.x,
      y: sourcePoint.y + this.getIrregularMargin(sourceAnchor),
    });
    newVertices.push({
      x: sourcePoint.x + (mouseEvent.clientX - startMouseX),
      y: sourcePoint.y + this.getIrregularMargin(sourceAnchor),
    });
    newVertices.push({ x: startPoint + (mouseEvent.clientX - startMouseX), y: vertices[i].y });
  }

  setLastHorizontalVertices(input: VerticeCalculatorInput, newVertices: joint.dia.Point[], mouseEvent: MouseEvent, verticeIndex: number) {
    const targetPoint = input.targetPoint;
    const targetAnchor = input.targetAnchor;
    const startPoint = input.startPoint;
    const vertices = input.vertices;
    const startMouseY = input.startMouseY;
    const i = verticeIndex;

    newVertices.push({ x: vertices[i].x, y: startPoint + (mouseEvent.clientY - startMouseY) });
    newVertices.push({
      x: targetPoint.x + this.getIrregularMargin(targetAnchor),
      y: startPoint + (mouseEvent.clientY - startMouseY),
    });
    newVertices.push({
      x: targetPoint.x + this.getIrregularMargin(targetAnchor),
      y: targetPoint.y,
    });
  }

  setLastVerticalVertices(input: VerticeCalculatorInput, newVertices: joint.dia.Point[], mouseEvent: MouseEvent, verticeIndex: number) {
    const targetPoint = input.targetPoint;
    const targetAnchor = input.targetAnchor;
    const startPoint = input.startPoint;
    const vertices = input.vertices;
    const startMouseX = input.startMouseX;
    const i = verticeIndex;

    newVertices.push({ x: startPoint + (mouseEvent.clientX - startMouseX), y: vertices[i].y });
    newVertices.push({
      x: startPoint + (mouseEvent.clientX - startMouseX),
      y: targetPoint.y + this.getIrregularMargin(targetAnchor),
    });
    newVertices.push({
      x: targetPoint.x,
      y: targetPoint.y + this.getIrregularMargin(targetAnchor),
    });
  }

  setMidHorizontalVertices(input: VerticeCalculatorInput, newVertices: joint.dia.Point[], mouseEvent: MouseEvent, verticeIndex: number) {
    const relatedVerticeIndex = input.relatedVerticeIndex;
    const startPointPrev = input.startPointPrev;
    const startPoint = input.startPoint;
    const vertices = input.vertices;
    const startMouseY = input.startMouseY;
    const i = verticeIndex;

    if (i === relatedVerticeIndex) {
      newVertices.push({ x: vertices[i].x, y: startPoint + (mouseEvent.clientY - startMouseY) });
    } else if (i === relatedVerticeIndex - 1) {
      newVertices.push({ x: vertices[i].x, y: startPointPrev + (mouseEvent.clientY - startMouseY) });
    } else {
      newVertices.push(vertices[i]);
    }
  }

  setMidVerticalVertices(input: VerticeCalculatorInput, newVertices: joint.dia.Point[], mouseEvent: MouseEvent, verticeIndex: number) {
    const relatedVerticeIndex = input.relatedVerticeIndex;
    const startPointPrev = input.startPointPrev;
    const startPoint = input.startPoint;
    const vertices = input.vertices;
    const startMouseX = input.startMouseX;
    const i = verticeIndex;

    if (i === relatedVerticeIndex) {
      newVertices.push({ x: startPoint + (mouseEvent.clientX - startMouseX), y: vertices[i].y });
    } else if (i === relatedVerticeIndex - 1) {
      newVertices.push({ x: startPointPrev + (mouseEvent.clientX - startMouseX), y: vertices[i].y });
    } else {
      newVertices.push(vertices[i]);
    }
  }
}
